<template>
  <div>
    <!-- Average Rating Binding Component -->
    <AverageRating v-if="isAvgRatingBinding" />

    <!-- Review And Rating Binding Component -->
    <ResponsiveComponent v-else>
      <!-- Mobile View Only -->
      <template #mobile>
        <LayoutOneMobile />
      </template>

      <!-- Desktop View Only -->
      <template #desktop>
        <LayoutOneDesktop />
      </template>
    </ResponsiveComponent>
  </div>
</template>

<script>
  import ResponsiveComponent from "@/components/Utilities/ResponsiveComponent/ResponsiveComponent.vue"
  import LayoutOneMobile from "./LayoutOneMobile.vue"
  import LayoutOneDesktop from "./LayoutOneDesktop.vue"
  import AverageRating from "@/components/ReviewAndRating/AverageRating/AverageRating.vue"
  import { BINDING_TYPE } from "@/constants/constants"

  export default {
    name: "LayoutOne",
    components: {
      AverageRating,
      ResponsiveComponent,
      LayoutOneDesktop,
      LayoutOneMobile,
    },
    props: {
      bindingType: {
        type: String,
        default: "",
      },
    },
    computed: {
      isAvgRatingBinding() {
        return this.bindingType === BINDING_TYPE.AVERAGE_RATING
      },
    },
  }
</script>
